/**
 * @file        src/pages/flight/CorporateCancellationList.jsx
 * @description Corporate Flight → Cancellation List. Same list as the B2C
 *              Flight Cancellation List (Cancellations.jsx), fixed to
 *              audience=b2b, instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Flight menu parity with B2C).
 */
import Cancellations from './Cancellations';

export default function CorporateCancellationList() {
  return (
    <Cancellations
      title="Corporate Cancellation List"
      subtitle="Corporate Flight · cancellations & refunds"
      audience="b2b"
    />
  );
}
